export default __webpack_public_path__ + "static/media/640_dummy2016-coach01-mobile-de.917d0c6c.png";